import { useState } from 'react';

import { Icons, Typography, Stack, tokens } from '@cast/design-system';

type AnomalyMarkerProps = {
  cx?: number;
  cy?: number;
  index: number;
  anomaliesAmount: number;
  onDisplayDetails(show: boolean): void;
};

const TOP_CHART_OFFSET = 4;

export const CostReportAnomalyMarker = ({
  cx = 0,
  cy = 0,
  index,
  anomaliesAmount,
  onDisplayDetails,
}: AnomalyMarkerProps) => {
  const [selected, setSelected] = useState(false);

  function handlePointerEnter() {
    setSelected(true);
    onDisplayDetails(true);
  }

  function handlePointerLeave() {
    setSelected(false);
    onDisplayDetails(false);
  }

  const showText = anomaliesAmount > 1;
  const boxWidth = showText ? 28 : 20;
  const boxHeight = 20;
  const chartHeight = cy; // cy is the very bottom coordinate of the chart
  const totalHeight = chartHeight - TOP_CHART_OFFSET;
  const errorStrong = tokens.theme.bg.status.errorStrong;

  return (
    <svg
      x={cx - boxWidth / 2}
      y={cy - totalHeight}
      width={boxWidth}
      height={totalHeight}
      fill="none"
      data-testid={`anomaly-marker-${index}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <foreignObject
        x={0}
        y={0}
        width={boxWidth}
        height={boxHeight}
        overflow="visible"
      >
        <Stack
          gap={2}
          direction="row"
          alignItems="center"
          height={boxHeight}
          bgcolor={tokens.theme.bg.structural.surface}
          p={4}
          borderRadius="4px"
          border={tokens.theme.border.structural.neutral}
          onPointerEnter={handlePointerEnter}
          onPointerLeave={handlePointerLeave}
          data-testid="head"
        >
          {showText && (
            <Typography
              variant="L10M"
              color={tokens.theme.fg.status.error}
              data-testid="amount"
            >
              {anomaliesAmount}
            </Typography>
          )}
          <Icons.Warning weight="fill" size={12} color={errorStrong} />
        </Stack>
      </foreignObject>
      <line
        x1={boxWidth / 2}
        y1={boxHeight}
        x2={boxWidth / 2}
        y2={totalHeight}
        stroke={errorStrong}
        strokeLinecap="round"
        strokeDasharray={selected ? undefined : '6 6'}
      />
    </svg>
  );
};
